@use '../../../scss/utility';
@use 'banner-teaser-vars';

:host {
  @include banner-teaser-vars.wb-banner-teaser-vars;

  display: block;
  position: relative;
}

.wrapper {
  position: relative;
  color: var(--banner-teaser-wrapper-color);
  background-color: var(--banner-teaser-wrapper-background-color);
  padding: var(--banner-teaser-wrapper-padding);
}

.wb-aspect-ratio {
  height: 100%;
}

.gradient {
  @include banner-teaser-vars.wb-banner-teaser-gradient-vars;

  position: absolute;
  inset-block-start: var(--banner-teaser-gradient-inset-block-start);
  inset-inline-start: var(--banner-teaser-gradient-inset-inline-start);
  width: var(--banner-teaser-gradient-width);
  height: var(--banner-teaser-gradient-height);
  background-image: var(--banner-teaser-gradient-background-image);
}

.content {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.tags {
  @include banner-teaser-vars.wb-banner-teaser-tags-vars;

  display: flex;
  position: relative;
  gap: var(--banner-teaser-tags-gap);
  padding: var(--banner-teaser-tags-padding);
  z-index: 1;

  @include utility.breakpoint-from('mq4') {
    @include banner-teaser-vars.wb-banner-teaser-tags-vars;
  }
}

.footer {
  display: flex;
  flex-wrap: wrap;
  gap: var(--banner-teaser-footer-gap);
}

::slotted(.wb-heading) {
  margin-block-end: var(--banner-teaser-heading-margin-block-end);
}

::slotted(.wb-text) {
  margin-block-end: var(--banner-teaser-text-margin-block-end);
}

::slotted(.wb-input[slot='footer']) {
  @include utility.breakpoint-to('mq2') {
    flex-basis: 100%;
  }

  @include utility.breakpoint-between('mq3', 'mq4') {
    flex: 1;
  }

  @include utility.breakpoint-from('mq4') {
    width: calc(4 * var(--wb-grid-column-width) + 3 * var(--wb-grid-gutter-width));
  }
}

@include utility.breakpoint-to('mq2') {
  .content {
    margin: 0 auto;
    width: var(--wb-grid-width);
  }
}

@include utility.breakpoint-from('mq3') {
  .wrapper {
    display: flex;
    gap: var(--wb-grid-gutter-width);
  }

  .wb-aspect-ratio {
    width: calc(var(--wb-grid-column-width) * 4 + var(--wb-grid-gutter-width) * 3);
  }

  .content {
    width: calc(var(--wb-grid-column-width) * 8 + var(--wb-grid-gutter-width) * 7);
  }
}

@include utility.breakpoint-between('mq3', 'mq5') {
  .wrapper {
    margin-inline-start: 0;
  }

  .wb-aspect-ratio {
    width: calc((50% - var(--wb-grid-width) / 2) + var(--wb-grid-column-width) * 4 + var(--wb-grid-gutter-width) * 3);
  }
}

:host(:not([fit-content])) {
  .wb-aspect-ratio {
    min-height: var(--banner-teaser-aspect-ratio-min-height);
  }
}

:host([full-width]) {
  @include banner-teaser-vars.wb-banner-teaser-full-width-vars;

  @include utility.breakpoint-from('mq3') {
    @include banner-teaser-vars.wb-banner-teaser-full-width-desktop-vars;
  }

  .content {
    @include banner-teaser-vars.wb-banner-teaser-content-vars;

    position: absolute;
    inset-block-start: var(--banner-teaser-content-inset-block-start);
    inset-inline-start: var(--banner-teaser-content-inset-inline-start);
    transform: translateY(-50%);

    @include utility.breakpoint-from('mq2') {
      @include banner-teaser-vars.wb-banner-teaser-content-mq2-vars;
    }

    @include utility.breakpoint-from('mq3') {
      @include banner-teaser-vars.wb-banner-teaser-content-mq3-vars;
    }

    @include utility.breakpoint-from('mq4') {
      @include banner-teaser-vars.wb-banner-teaser-content-mq4-vars;
    }

    @include utility.breakpoint-from('mq5') {
      @include banner-teaser-vars.wb-banner-teaser-content-mq5-vars;
    }

    @include utility.breakpoint-from('mq6') {
      @include banner-teaser-vars.wb-banner-teaser-content-mq6-vars;
    }
  }

  .wb-aspect-ratio {
    width: 100%;
  }
}

:host(:not([full-width])) {
  @include utility.breakpoint-to('mq2') {
    .wb-aspect-ratio {
      margin-block-end: var(--wb-spacing-s);
    }
  }

  ::slotted(.wb-button[slot='footer']) {
    @include utility.breakpoint-to('mq2') {
      flex-basis: 100%;
    }
  }
}

:host(:not([top-padding='false'])) {
  @include banner-teaser-vars.wb-banner-teaser-top-padding-vars;
}
